export function padArray(arr: any[], length: number, pad?: any) {
  const r = [...arr]
  while (r.length < length) {
    r.push(pad ?? {})
  }
  return r
}
